import { motion } from "framer-motion";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const BlockDiferencial = ({ diferencia1, diferencia2, diferencia3 }) => {
  // Guardamos las props en un array de configuración limpia
  const cards = [
    { key: "dif1", content: diferencia1 },
    { key: "dif2", content: diferencia2 },
    { key: "dif3", content: diferencia3 },
  ];

  // Si no se pasa la primera diferencia (o ninguna), no se renderiza el bloque
  if (!diferencia1) return null;

  return (
    <section className="bg-[#004270] py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Título */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="uppercase tracking-widest text-amber-400 text-sm font-semibold">
            Diferenciales
          </span>
          <h2 className="font-bold text-white text-3xl mt-2">
            ¿Qué nos diferencia?
          </h2>
        </motion.div>

        {/* Cards */}
        <motion.div
          className="grid gap-8 md:grid-cols-3"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
        >
          {cards.map(({ key, content }) => {
            // Si esa prop en específico viene vacía, no renderiza esa tarjeta
            if (!content) return null;

            return (
              <motion.div
                key={key}
                variants={cardVariants}
                className="rounded-3xl border border-white/15 bg-white/8 p-8 text-white"
              >
                {/* Aquí renderizamos directamente el JSX que enviaste.
                  Cualquier clase CSS que afecte a los hijos (p, strong, ul) se puede aplicar aquí 
                */}
                <div className="[&_p]:text-slate-200 [&_strong]:text-white [&_ul]:space-y-3 [&_li]:text-slate-200">
                  {content}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default BlockDiferencial;